import { Router } from "@frui.ts/screens/dist";
import StatusViewModel from "./statusViewModel";

export const SingleStatusViewNavigationName = "single_status";

@Router.registerRoute({ route: `${SingleStatusViewNavigationName}/:orderId`, name: Router.Self })
export default class SingleStatusViewModel extends StatusViewModel {}
